/* DEPRECATED */
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';
import formField from 'Components/frameworks/form-field/FormField.jsx';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';

const propTypes = {
  dataSelector: PropTypes.string,
  height: PropTypes.string,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      isDisabled: PropTypes.bool,
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  placeholder: PropTypes.string,
};

const defaultProps = {
  dataSelector: 'FormSelect',
  isDisabled: false,
  isReadOnly: false,
  isRequired: false,
  onBlur() {},
  onChange() {},
  onClear() {},
  onClick() {},
  onFocus() {},
  onKeyDown() {},
  onKeyUp() {},
  options: [],
};

class FormSelect extends React.Component<Props> {
  static displayName = 'FormSelect';

  constructor(props) {
    super(props);

    this.state = {
      value: props.value || '',
    };
  }

  UNSAFE_componentWillReceiveProps({ value }) {
    if (this.props.value !== value) {
      this.setState({ value });
    }
  }

  onChange = e => {
    if (!this.props.isReadOnly) {
      e.persist();
      const { value } = e.target;

      this.props.onChange(value);

      this.setState({
        value,
      });
    }
  };

  onClear = () => {
    this.props.onClear();
    this.setState({
      value: '',
    });
  };

  getOptions = () => {
    if (!this.props.options.length) {
      return null;
    }

    return this.props.options.map(({ label, value, isDisabled }) => {
      return label.trim() ? (
        <option disabled={isDisabled} key={value} label={label.trim()} value={value}>
          {label}
        </option>
      ) : null;
    });
  };

  render() {
    const { value } = this.state;
    const {
      dataSelector,
      height,
      id,
      isDisabled,
      isLoading,
      isReadOnly,
      isRequired,
      name,
      onBlur,
      onClick,
      onFocus,
      onKeyDown,
      onKeyUp,
      placeholder,
    } = this.props;

    return (
      <div className="cursor-pointer flex-1 relative">
        <select
          className={classnames(
            'reset-input reset-select bg-transparent py-3 px-4 rtl:pr-10 text-md w-full',
            {
              'text-gray-darker': value,
              'text-gray-dark': !value,
              'pointer-events-none': isReadOnly,
              'cursor-not-allowed': isDisabled,
              'cursor-progress': isLoading && !isDisabled,
            },
          )}
          data-selector={dataSelector}
          data-testid={dataSelector}
          disabled={isDisabled}
          id={id}
          name={name}
          onBlur={onBlur}
          onChange={this.onChange}
          onClick={onClick}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          readOnly={isReadOnly}
          required={isRequired}
          style={{
            height,
          }}
          value={value}
        >
          {!!placeholder && (
            <option
              data-testid="FormSelectPlaceholder"
              label={placeholder.trim()}
              disabled
              value=""
            >
              {isRequired ? `${placeholder}*` : placeholder}
            </option>
          )}
          {this.getOptions()}
        </select>
        {!isReadOnly && (
          <div className="absolute flex h-full items-center top-0 pointer-events-none px-3 rtl:right-0">
            <Icon name={ICONS.SELECT} />
          </div>
        )}
      </div>
    );
  }
}

FormSelect.propTypes = propTypes;
FormSelect.defaultProps = defaultProps;

export default formField(FormSelect);
